<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-card-title class="pa-0">
            <v-system-bar window color="accent" dark style="width: 100%">
              <v-btn flat @click="expanded.my=!expanded.my">Мои статистики<v-icon>{{expanded.my?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <v-btn small icon slot="activator" @click="openStatisticForm(false)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
                <span>Добавить статистику</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn small icon slot="activator" @click="openFolderForm(false)" class="mx-0"><v-icon class="mx-0">mdi-folder-plus</v-icon></v-btn>
                <span>Создать новую папку</span>
              </v-tooltip>
            </v-system-bar>
          </v-card-title>
          <v-card-text class="statistics-list px-0 py-2" v-show="expanded.my">
              <dantser-tree
                ref="myFoldersTree"
                :selectMode="2"
                :source="indicators.my"
                :style="{height:'calc(100% - 20px)', overflow: 'scroll', 'padding-bottom':'10px'}"
                @click-node="getStatistic($event)"
                @ctx-menu="openCtxMenu($event, 'my')"
              ></dantser-tree>
          </v-card-text>
        </v-card>
        
        <v-card class="mt-3">
          <v-card-title class="pa-0">
            <v-system-bar window color="accent" dark style="width: 100%">
              <v-btn flat @click="expanded.shared=!expanded.shared">Доступные мне<v-icon>{{expanded.my?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
            </v-system-bar>
          </v-card-title>
          <v-card-text class="statistics-list px-0 py-2" v-show="expanded.shared">
            <dantser-tree
              ref="otherFoldersTree"
              :selectMode="2"
              :source="indicators.other"
              :style="{height:'calc(100% - 20px)', overflow: 'scroll', 'padding-bottom':'10px'}"
              @click-node="getStatistic($event)"
              @ctx-menu="openCtxMenu($event, 'shared')"
            ></dantser-tree>
          </v-card-text>
        </v-card>
  
        <v-card class="mt-3">
          <v-card-title class="pa-0">
            <v-system-bar window color="accent" dark style="width: 100%">
              <v-btn flat @click="expanded.trash=!expanded.trash">Корзина<v-icon>{{expanded.trash?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <v-btn small icon slot="activator" @click="clearTrash" class="mx-0"><v-icon class="mx-0">mdi-delete</v-icon></v-btn>
                <span>Очистить корзину</span>
              </v-tooltip>
            </v-system-bar>
          </v-card-title>
          <v-card-text class="statistics-list px-0 py-2" v-show="expanded.trash">
            <dantser-tree
              ref="trashTree"
              :selectMode="2"
              :source="indicators.trash"
              :style="{height:'calc(100% - 20px)', overflow: 'scroll', 'padding-bottom':'10px'}"
              @click-node="getStatistic($event)"
              @ctx-menu="openCtxMenu($event, 'trash')"
            ></dantser-tree>
          </v-card-text>
        </v-card>
      </v-flex>
  
      <v-flex xs12 md8 lg9 :style="{height:blockHeight, 'overflow-y':'auto', position: 'relative'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-chart-line</v-icon>
            <v-toolbar-title class="ml-1">Статистика</v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-tooltip top v-if="mode==='fill'">
              <v-btn icon slot="activator" @click="openExportForm" class="mx-0"><v-icon class="mx-0">mdi-upload-multiple</v-icon></v-btn>
              <span>Экспорт данных</span>
            </v-tooltip>
            <v-tooltip top v-if="showSettingIcon">
              <v-btn icon slot="activator" @click="getSetting(selectedStatistic, null)" class="mx-0"><v-icon class="mx-0">mdi-settings</v-icon></v-btn>
              <span>Настройки {{mode==='fill' ? 'ввода' : 'вывода'}}</span>
            </v-tooltip>
          </v-system-bar>
          
          <v-flex xs12 v-if="selectedStatistic">
            <v-flex xs12 class="text-xs-center" v-if="loaded">
              <template v-if="mode==='table'">
                <div class="text-xs-center my-3">
                  <span class="pull-left" v-if="statistic.unit">Ед. изм. : {{statistic.unit}}</span>
                  <span class="title blue-grey--text">{{statistic.name}}</span>
                  <v-btn small class="pull-right blue-grey white--text" @click="getStatistic({id:selectedStatistic, element_type:'statistic'})">График</v-btn>
                </div>
          
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-actions
                  no-data-text="Данные не введены"
                  class="statistic-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center"> {{ props.item.name }} </td>
                    <td class="text-xs-center" v-for="(el, index) in props.item.data" :key="index">{{el.value}}</td>
                  </template>
                </v-data-table>
              </template>
              
              <template v-else-if="mode==='fill'">
                <v-flex xs12 v-if="!has_objects" class="text-xs-center py-4 grey--text">
                  <span class="headline">Список объектов пуст. Добавьте объекты для ввода данных, либо отвяжите показатели от объектов оргструктуры.</span>
                </v-flex>
                <template v-else>
                  <div class="ma-3 mb-0">
                    <v-switch class="pull-left ma-0" label="Показать неактивные" v-model="showDeleted"></v-switch>
                    <span class="subheading">{{currentNode.name}}</span>
                    <v-btn color="primary" class="pull-right ma-0" @click="addData" small>Добавить данные</v-btn>
                  </div>
                  <indicator-table :deleted_objects="headers_deleted" :deleted_data="deleted_data" :objects="headers_fill" :data="label_data"
                                   :showDeleted="showDeleted" :loading="loading" @save="saveValue" :canEdit="currentNode.can_filling"></indicator-table>
                  <div class="text-xs-left">
                    <v-btn v-if="has_data" color="primary" @click="fetchData" small class="my-4">Показать еще данные</v-btn>
                    <p v-else class="pa-4">Все данные загружены</p>
                  </div>
                </template>
              </template>
              
              <d-statistic v-else :statistic="statistic" :height="7/16*100+'%'" with_periods with_table :sets="sets" @change-period="changePeriod($event)" @table-view="tableMode"></d-statistic>
            </v-flex>
            <v-flex xs12 class="text-xs-center pt-5" v-else>
              <p>Загрузка ...</p>
              <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  
    <context-menu id="statistics-context-menu" ref="ctxMenu">
      <li @click="infoStatistic" v-if="currentNode"><v-icon size="18">mdi-information</v-icon> Информация</li>
      <li @click="restoreElement" v-if="currentTree==='trash'"><v-icon size="18">mdi-restore</v-icon> Восстановить</li>
      <li @click="getTableData" v-if="currentTree!=='trash' && currentNode && currentNode.can_filling"><v-icon size="18">mdi-table</v-icon> Режим ввода</li>
      <li @click="openStatisticForm(true)" v-if="currentTree!=='trash' && currentNode && currentNode.can_edit"><v-icon size="18">mdi-pencil</v-icon> Редактировать</li>
      <li @click="getSetting(currentNode.id, 0)" v-if="currentTree!=='trash' && currentNode && currentNode.can_filling"><v-icon size="18">mdi-login-variant</v-icon> Настройки ввода</li>
      <li @click="getSetting(currentNode.id, 1)" v-if="currentTree!=='trash' && currentNode"><v-icon size="18">mdi-logout-variant</v-icon> Настройки вывода</li>
      <li @click="deleteStatistic" v-if="currentNode && currentNode.can_edit"><v-icon size="18">mdi-delete</v-icon> Удалить</li>
      
      <li @click="openFolderForm(true)" v-if="currentTree!=='trash' && currentFolder && currentFolder.can_edit"><v-icon size="18">mdi-pencil</v-icon> Редактировать</li>
      <li @click="openStatisticForm(false, currentFolder.id)" v-if="currentTree==='my' && currentFolder"><v-icon size="18">mdi-finance</v-icon> Добавить статистику</li>
      <li @click="deleteFolder" v-if="(currentFolder && currentFolder.can_edit) || (currentFolder && currentTree==='trash')"><v-icon size="18">mdi-delete</v-icon> Удалить</li>
    </context-menu>
    
  </v-container>
</template>

<script>
  const NAME_SEPARATOR = '\n'
  
  import DStatistic from './Statistic'
  import SimpleStatisticForm from './Forms/SimpleStatisticForm'
  import IndicatorTable from './IndicatorTable'
  import DataDateForm  from './Forms/DataDateForm'
  import FolderForm from './Forms/FolderForm'
  import SettingsForm from './Forms/SettingsForm'
  import StatisticsInfo from './Forms/StatisticsInfo'
  import ExportForm from './Forms/ExportForm'
  import contextMenu from 'vue-context-menu'
  
  import {mapGetters} from 'vuex'
  import entities from '@/mixins/entities/old'
  
  export default {
    name : 'StatisticsList',
    
    components:{
      DStatistic,
      IndicatorTable,
      contextMenu,
    },
    
    mixins: [entities],
    
    data(){
      return{
        formProps: {},
        dialog: false,
        loaded: false,
        loading: false,
        selectedStatistic: null,
        statistic: {},
        currentComponent: null,
        mode: 'graph',
        headers: [],
        items: [],
        label_data: [],
        label_objects: [],
        deleted_data: [],
        deleted_objects: [],
        currentNode: null,
        currentFolder: null,
        currentTree: 'my',
        has_objects: false,
        has_data: true,
        showDeleted: false,
        expanded: {
          my: true,
          shared: true,
          trash: false,
        },
        dialogWidth: 1000,
      }
    },
  
    computed:{
      headers_fill(){
        return [{
          text: 'Дата',
          align: 'center',
          sortable: false,
          class: 'data-table-header',
          width: 120
        }].concat(this.label_objects)
      },
      headers_deleted(){
        return [{
          text: 'Дата',
          align: 'center',
          sortable: false,
          class: 'data-table-header',
          width: 120
        }].concat(this.deleted_objects)
      },
      accesses(){
        return this.$store.state.app.account.accesses['analytics'] || {}
      },
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      showSettingIcon(){
        return this.loaded && this.selectedStatistic && (this.mode==='graph' || this.mode==='fill')
      },
      ...mapGetters('analytics_old/sets', ['sets']),
      ...mapGetters('analytics_old/indicators', ['indicators']),
      ...mapGetters('app/helpers',['formatDatetime']),
      ...mapGetters('app/org', ['getPostById', 'getContainerById']),
    },
    
    created(){
      this.$store.dispatch('analytics_old/indicators/list')
      this.$store.dispatch('analytics_old/sets/list')
      if(this.accesses.drivers_access) this.$store.dispatch('analytics_old/drivers/list')
      if(this.$route.query.id){
        this.tableMode(this.$route.query.id)
      }
    },
    
    methods: {
      changePeriod(data){
        data.element_type = 'statistic'
        this.getStatistic(data, data.period_type)
      },
  
      getStatistic(item, period){
        if(item.element_type==='statistic'){
          let parameters = {}
          if ( typeof period !== 'undefined' ){
            parameters = { period_type: period}
          }
          this.mode = 'graph'
          this.loaded = false
          this.selectedStatistic = item.id
          this.$store.dispatch('analytics_old/statistics/getData', {id: item.id, type: 'label',mode: 'graph', data: parameters }).then( response => {
            this.statistic = response
            this.statistic.entity_type = 'label'
            this.loaded = true
            this.convertOutputSettings(response.lines)
          })
        } else {
          item.expanded = true
        }
      },
  
      infoStatistic(){
        this.formProps = {
          data: this.currentNode
        }
        this.dialogWidth = 1000
        this.currentComponent = StatisticsInfo
        this.dialog = true
      },
  
      openFolderForm(edit=false){
        if(!edit) this.currentTree = 'my'
        let type = (this.currentTree==='my') ? 0 : 3
        this.formProps = {}
        if(edit){
          this.formProps = {
            data: {
              id: this.currentFolder.id,
              name: this.currentFolder.name,
              parent_id: this.currentFolder.parent_id,
              owner_id: this.currentFolder.owner_id || "",
            },
            editMode: true,
            type: type
          }
        }
        this.dialogWidth = 1000
        this.currentComponent = FolderForm
        this.dialog = true
      },
      
      openStatisticForm(edit=false, parent_id = null){
        if(!edit) this.currentTree = 'my'
        let type = (this.currentTree==='my') ? 0 : 3
        this.formProps = {parent_id}
        if(edit){
          this.formProps = {  data: this.currentNode, editMode: true, type, parent_id }
        }
        this.dialogWidth = 1200
        this.currentComponent = SimpleStatisticForm
        this.dialog = true
      },
  
      openExportForm(){
        this.formProps = {
          id: this.selectedStatistic,
          lines: this.label_objects
        }
        this.dialogWidth = 800
        this.currentComponent = ExportForm
        this.dialog = true
      },
      
      deleteStatistic(){
        this.$dmsAgree('Вы уверены, что хотите удалить выбранную статистику?').then(_ => {
          this.$store.dispatch('analytics_old/indicators/delete', this.currentNode.id).then( response => {
            let tree = this.$refs.myFoldersTree
            switch(this.currentTree){
              case 'my': tree = this.$refs.myFoldersTree; break
              case 'shared': tree = this.$refs.otherFoldersTree; break
              case 'trash': tree = this.$refs.trashTree; break
            }
            let node = tree.deleteNodeById(this.currentNode.id)
            if(this.currentTree==='my' && node!=null){
              this.indicators.trash.unshift(node[0])
            }
            this.$store.commit('analytics_old/indicators/setIndicators', this.indicators)
          })
        })
      },
  
      deleteFolder(){
        this.$dmsAgree('Вы уверены, что хотите удалить выбранную папку?').then(_ => {
          this.$store.dispatch('analytics_old/indicators/deleteFolder', this.currentFolder.id).then( response => {
            let tree = this.$refs.myFoldersTree
            switch(this.currentTree){
              case 'my': tree = this.$refs.myFoldersTree; break
              case 'shared': tree = this.$refs.otherFoldersTree; break
              case 'trash': tree = this.$refs.trashTree; break
            }
            let node = tree.deleteNodeById(this.currentFolder.id)
            if(this.currentTree==='my' && node!=null){
              this.indicators.trash.unshift(node[0])
            }
            this.$store.commit('analytics_old/indicators/setIndicators', this.indicators)
          })
        })
      },
  
      getTableData(){
        this.offset = 0
        this.mode = 'fill'
        this.loaded = false
        this.showDeleted = false
        this.selectedStatistic = this.currentNode.id
        this.deleted_data = []
        this.deleted_objects = []
        this.label_data = []
        this.label_objects = []
        this.fetchData()
      },
  
      fetchData(){
        this.loading = true
        this.$store.dispatch('analytics_old/indicators/getTable', {id: this.currentNode.id, offset: this.offset}).then( response => {
          this.loaded = true
          this.loading = false
          this.has_objects = ((response.active && response.active.length>0) || (response.no_active && response.no_active.length>0))
          //Заполнить объекты при их наличии и только при первой загрузке
          if(this.offset===0 && this.has_objects){
            this.convertTableObjects(response.active, response.no_active, this.label_objects, this.deleted_objects, NAME_SEPARATOR)
          }
          if(response.label_data && response.label_data.length>0){
            this.has_data = true
            this.offset++
            let total = []
            let total_d = []
        
            response.label_data.forEach( item => {
              //Занесение данных для активных объектов
              let temp = {}
              temp.date = item.date
              temp.dateFormatted = this.formatDatetime(item.date).dots
              temp.data = []
          
              this.label_objects.forEach( obj => {
                const index = item.data.findIndex( el => this.isEqualArrays(el.objects_ids, obj.value) )
                if(index>-1) temp.data.push( {
                  objects_ids: obj.value,
                  value: item.data[index].value,
                  date: item.date,
                })
                else temp.data.push({objects_ids: obj.value, value: '', date: item.date})
              })
              total.push(temp)
  
              //Занесение данных для неактивных объектов
              let temp_d = {}
              temp_d.date = item.date
              temp_d.dateFormatted = this.formatDatetime(item.date).dots
              temp_d.data = []
  
              this.deleted_objects.forEach( obj => {
                const index = item.data.findIndex( el => el.objects_ids===obj.value)
                if(index>-1) temp_d.data.push( {
                  objects_ids: obj.value,
                  value: item.data[index].value,
                  date: item.date
                })
                else temp_d.data.push({objects_ids: obj.value, value: '', date: item.date})
              })
              total_d.push(temp_d)
            })
            this.deleted_data = this.deleted_data.concat(total_d)
            this.label_data = this.label_data.concat(total)
          } else {
            this.has_data = false
          }
        })
      },
  
      addData(){
        this.formProps = {}
        this.dialogWidth = 600
        this.currentComponent = DataDateForm
        this.dialog = true
      },
  
      pushRow(data){
        let temp = {}
        temp.date = data.date
        temp.dateFormatted = data.dateFormatted
        temp.data = []
        temp.selected = true
    
        if(this.showDeleted){
          this.deleted_objects.forEach( obj => {
            temp.data.push({objects_ids: obj.value, value: '', date: data.date})
          })
          
          let inputIndex = this.deleted_data ? this.deleted_data.length : 0
          this.deleted_data.some( (el, index) => {
            const d1 = new Date(el.date).getTime()
            const d2 = new Date(data.date).getTime()
            if(d2>d1) {
              inputIndex = index
              return true
            }
          })
          this.deleted_data.splice(inputIndex, 0, temp)
        } else {
          this.label_objects.forEach( obj => {
            temp.data.push({objects_ids: obj.value, value: '', date: data.date})
          })
          
          let inputIndex = this.label_data ? this.label_data.length : 0
          this.label_data.some( (el, index) => {
            const d1 = new Date(el.date).getTime()
            const d2 = new Date(data.date).getTime()
            if(d2>d1) {
              inputIndex = index
              return true
            }
          })
          this.label_data.splice(inputIndex, 0, temp)
        }
        this.startTimer()
      },
  
      saveValue(item){
        item.label_id = this.currentNode.id,
        this.$store.dispatch('analytics_old/indicators/saveValue', item).catch( err => {
          this.$dmsErrorNoty('Данные не изменены. Попробуйте снова.')
          item.value = ''+item.prevValue
          if(err.response.status === 403 ) {
            this.$root.$info('Нет доступа', err.response.error).then( )
          }
        })
      },
      
      startTimer(){
        setTimeout( () => {
          if(this.showDeleted){
            this.deleted_data.map( el => {
              el.selected = false
            })
          } else {
            this.label_data.map( el => {
              el.selected = false
            })
          }
        }, 6000)
      },
  
      saveChanges(eventData){
        switch(eventData.type){
          case 'value':
              this.pushRow(eventData)
            break
          case 'folder':
              this.saveNode(eventData.data)
            break
          case 'statistic':
              this.saveNode(eventData.data)
            break
          case 'settings':
            this.resetSettings(eventData.data)
            break
          case 'resetSettings':
            this.resetSettings(eventData.data)
            break
        }
        this.dialog = false
      },
  
      saveNode(data){
        if(this.currentTree === 'shared'){
          let node = this.$refs.otherFoldersTree.getNodeById(data.id)
          //Если существует папка - отредактировать, если нет - добавить
          if(node){
            node.name = data.name
            node.description = data.description
            node.invert_chart = data.invert_chart
            node.period_type = data.period_type
            node.unit = data.unit
            // Если сменился родитель - перенести

            if((node.parent_id !== data.parent_id) && data.parent_id!=null) {
              let parent = this.$refs.otherFoldersTree.getNodeById(data.parent_id)
              this.$refs.otherFoldersTree.deleteNodeById(data.id)
              let index = parent.children.length
              parent.children.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              parent.children.splice(index, 0, node)
            }
          } else {
            if(data.parent_id==null){
              let index = this.indicators.other.length
              this.indicators.other.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              this.indicators.other.splice(index, 0, data)
            } else {
              let parent = this.$refs.otherFoldersTree.getNodeById(data.parent_id)
              let index = parent.children.length
              parent.children.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              parent.children.splice(index, 0, data)
            }
          }
        } else if(this.currentTree === 'my'){
          let node = this.$refs.myFoldersTree.getNodeById(data.id)
          //Если существует папка - отредактировать, если нет - добавить
          if(node){
            node.name = data.name
            node.description = data.description
            node.invert_chart = data.invert_chart
            node.period_type = data.period_type
            node.unit = data.unit
            // Если сменился родитель - перенести
            if((node.parent_id !== data.parent_id) && data.parent_id!=null) {
              let parent = this.$refs.myFoldersTree.getNodeById(data.parent_id)
              this.$refs.myFoldersTree.deleteNodeById(data.id)
              let index = parent.children.length
              parent.children.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              parent.children.splice(index, 0, node)
            }
          } else {
            if(data.parent_id==null){
              let index = this.indicators.my.length
              this.indicators.my.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              this.indicators.my.splice(index, 0, data)
            } else {
              let parent = this.$refs.myFoldersTree.getNodeById(data.parent_id)
              let index = parent.children.length
              parent.children.some( (el, i) => {
                if(el.element_type==='statistic'){
                  index = i
                  return true
                }
              })
              parent.children.splice(index, 0, data)
            }
          }
        }
        this.$store.commit('analytics_old/indicators/setIndicators', this.indicators)
      },
  
      openCtxMenu(item, tree) {
        this.currentTree = tree
        if(item.data.element_type==='statistic'){
          this.currentNode = item.data
          this.currentFolder = null
        } else {
          this.currentFolder = item.data
          this.currentNode = null
        }
        if((this.currentFolder && this.currentFolder.can_edit) || this.currentNode || tree==='trash'){
          this.$refs.ctxMenu.open()
        }
      },
  
      tableMode(id){
        this.mode = 'table'
        this.loaded = false
        this.selectedStatistic = id
        this.$store.dispatch('analytics_old/statistics/getData', {id: id, type: 'label', mode: 'table', data: {} }).then( response => {
          this.loaded = true
          this.statistic = response.statistic
          this.headers = [{
            text: 'Объект',
            sortable: false,
            align: 'center',
            class: 'stat-table-header'
          }]
          response.dates.forEach( item => {
            this.headers.push({
              text: item,
              sortable: false,
              align: 'center',
              class: 'stat-table-header'
            })
          })
  
          this.items = []
          response.statistic.lines.forEach( item => {
            let temp = {}
            temp.name = item.name
            temp.data = []
  
            response.dates.forEach( obj => {
              const index = item.data.findIndex( el => el.date === obj )
              if( index > -1 ) temp.data.push( { value : item.data[ index ].value, date : obj } )
              else temp.data.push( { value : '', date : obj } )
            })
            this.items.push( temp )
          })
        })
      },
  
      getSetting(id, type){
        if(type==null){
          type = (this.mode==='fill') ? 0 : 1
        }
        this.$store.dispatch('analytics_old/indicators/getSettings', {id, type}).then(response =>{
          if(type===0){
            this.dialogWidth = 1200
            this.convertUuidsToNames(response.setting)
          } else {
            this.dialogWidth = 1000
            this.convertOutputSettings(response.setting)
          }
          
          this.formProps = {
            objects: response.objects,
            settings: response.setting,
            is_default: response.default,
            output: (type===1),
            label_id: id
          }
          this.currentComponent = SettingsForm
          this.dialog = true
        })
      },
      
      resetSettings(data){
        if(data.label_id === this.selectedStatistic){
          if(data.output){
            this.getStatistic({id:data.label_id, element_type:'statistic'})
          } else {
            this.getTableData()
          }
        }
      },
      
      clearTrash(){
        this.$dmsAgree('Удаленные из корзины элементы невозможно будет восстановить. Вы уверены, что хотите очистить корзину?').then(_ => {
          this.$store.dispatch('analytics_old/indicators/deleteAll')
        })
      },
  
      isEqualArrays(arr1, arr2){
        if(arr1.length!==arr2.length) return false
        return arr1.every( el => {
          return arr2.includes(el)
        })
      },
  
      restoreElement(){
        if(this.currentNode!=null){
          this.$store.dispatch('analytics_old/indicators/restoreLabel', this.currentNode.id).then( response => {
            let node = this.$refs.trashTree.deleteNodeById(this.currentNode.id)
            if(node){
              this.indicators.my.push(node[0])
            }
            this.$store.commit('analytics_old/indicators/setIndicators', this.indicators)
          })
        } else if(this.currentFolder!=null){
          this.$store.dispatch('analytics_old/indicators/restoreFolder', this.currentFolder.id).then( response => {
            let node = this.$refs.trashTree.deleteNodeById(this.currentFolder.id)
            if(node){
              this.indicators.my.push(node[0])
            }
            this.$store.commit('analytics_old/indicators/setIndicators', this.indicators)
          })
        }
      }
    }
  }
  
</script>

<style lang="scss">
  .stat-table-header{
    white-space: normal !important;
    width: 60px !important;
  }
  .statistic-data-table table.table td, .statistic-data-table table.table thead tr:first-child th{
    height: 30px !important;
    padding: 0 8px !important;
  }
  .statistic-data-table table.table thead tr {
    height: 30px;
  }
  #statistics-context-menu ul.ctx-menu{
    min-width: 185px;
  }
  #statistics-context-menu ul.ctx-menu li{
    padding: 6px 7px 6px 10px;
    cursor: pointer;
    font-size: 14px;
  }
  #statistics-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #statistics-context-menu ul.ctx-menu li i{
    width: 20px;
  }
  .statistics-list{
    height: calc(100% - 48px);
    width: 100%;
    position: relative;
     &__item{
        position: absolute;
        left: 0;
        width: 100%;
        height: calc(50% - 10px);
        overflow: auto;
      }
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/StatisticsList.vue